(function () {
  var HASH = '#personalize';
  var PREVIEW_ALT = 'Your custom blanket preview';
  var SAMPLE_PRODUCT_IMAGE = '';
  var PLACEHOLDER_IMAGE_RE =
    /1f1aa268-96b5-6d12-b27b-7273a1cef74b|add-your-dog|your-photo-placeholder|pawlinen-carousel-|pupprint-pdp-poster|pupprint-ugc-/i;
  var lastPreviewUrl = '';
  var lastPreviewUrls = [];
  var pendingRenderUrls = [];
  var lastPersonalizationId = '';
  var previewGen = 0;
  var pickedMediaId = '';
  var sizeBeforePersonalize = '';
  var ignorePrintifyRestore = false;
  var allowPersonalizeClick = false;
  var PRINTIFY_PRODUCT_ID = '6a9d5fd75dcc44782c040e8f';
  var PRINTIFY_VARIANT_50 = '41656';
  var PRINTIFY_SKU_50 = '25414076499901019141';
  var PRINTIFY_MOCKUPS = [
    { id: '439', label: 'Front' },
    { id: '441', label: 'Folded' },
    { id: '6408', label: 'Draped' },
    { id: '6410', label: 'Lifestyle' },
  ];
  var PRINTIFY_MOCKUP_IDS = PRINTIFY_MOCKUPS.map(function (mockup) {
    return String(mockup.id);
  });

  function personalizeButton() {
    return Array.prototype.find.call(document.querySelectorAll('button'), function (button) {
      var text = (button.textContent || '').replace(/\s+/g, ' ').trim();
      return /upload your dog|personalize|change photo/i.test(text);
    });
  }

  function isHeicFile(file) {
    if (!file) return false;
    var type = (file.type || '').toLowerCase();
    var name = (file.name || '').toLowerCase();
    return (
      type === 'image/heic' ||
      type === 'image/heif' ||
      type === 'image/heic-sequence' ||
      /\.heic$|\.heif$/.test(name)
    );
  }

  function loadImage(url) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.onload = function () {
        resolve(img);
      };
      img.onerror = function () {
        reject(new Error('Could not decode photo'));
      };
      img.src = url;
    });
  }

  function canvasToJpeg(img, name) {
    return new Promise(function (resolve, reject) {
      var canvas = document.createElement('canvas');
      canvas.width = img.naturalWidth || img.width;
      canvas.height = img.naturalHeight || img.height;
      if (!canvas.width || !canvas.height) return reject(new Error('Empty photo'));
      canvas.getContext('2d').drawImage(img, 0, 0);
      canvas.toBlob(function (blob) {
        if (!blob) return reject(new Error('Convert failed'));
        resolve(
          new File([blob], String(name || 'photo.jpg').replace(/\.(heic|heif)$/i, '.jpg'), {
            type: 'image/jpeg',
          })
        );
      }, 'image/jpeg', 0.92);
    });
  }

  function heic2anyConvert(file) {
    return new Promise(function (resolve, reject) {
      function run() {
        window
          .heic2any({ blob: file, toType: 'image/jpeg', quality: 0.92 })
          .then(function (blob) {
            var out = Array.isArray(blob) ? blob[0] : blob;
            resolve(
              new File([out], String(file.name || 'photo.jpg').replace(/\.(heic|heif)$/i, '.jpg'), {
                type: 'image/jpeg',
              })
            );
          })
          .catch(reject);
      }
      if (window.heic2any) return run();
      var script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js';
      script.onload = run;
      script.onerror = function () {
        reject(new Error('Converter failed to load'));
      };
      document.head.appendChild(script);
    });
  }

  function fileToJpeg(file) {
    var url = URL.createObjectURL(file);
    return loadImage(url)
      .then(function (img) {
        URL.revokeObjectURL(url);
        return canvasToJpeg(img, file.name || 'photo.jpg');
      })
      .catch(function () {
        URL.revokeObjectURL(url);
        return heic2anyConvert(file);
      });
  }

  function replaceInputFiles(input, files) {
    var transfer = new DataTransfer();
    files.forEach(function (file) {
      transfer.items.add(file);
    });
    input.files = transfer.files;
  }

  function hookHeicInputs(root) {
    root = root || document;
    if (!root || root.__pupprintHeicHooked) return;
    root.__pupprintHeicHooked = true;
    root.addEventListener(
      'change',
      function (event) {
        var input = event.target;
        if (!input || input.type !== 'file' || input.__pupprintConverting) return;
        var files = input.files ? Array.prototype.slice.call(input.files) : [];
        if (!files.some(isHeicFile)) return;
        event.stopImmediatePropagation();
        event.stopPropagation();
        input.__pupprintConverting = true;
        Promise.all(
          files.map(function (file) {
            return isHeicFile(file) ? fileToJpeg(file) : Promise.resolve(file);
          })
        )
          .then(function (converted) {
            replaceInputFiles(input, converted);
            input.__pupprintConverting = false;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          })
          .catch(function () {
            input.__pupprintConverting = false;
            if (typeof window.pupprintTrack === 'function') {
              window.pupprintTrack('upload_photo_error', { reason: 'heic_convert_failed' });
            }
            window.alert(
              'That photo did not upload. Try a JPEG or PNG instead.'
            );
          });
      },
      true
    );
  }

  function hookHeicFrames() {
    hookHeicInputs(document);
    Array.prototype.forEach.call(document.querySelectorAll('iframe'), function (frame) {
      try {
        if (frame.contentDocument) hookHeicInputs(frame.contentDocument);
      } catch (err) {}
    });
  }

  function modalVisible() {
    var modal = document.querySelector('[id^="personalizeModal"], [class*="personalize-modal"]');
    if (!modal) return false;
    var style = window.getComputedStyle(modal);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function personalizationData() {
    var state = window.personalizationSharedState;
    return (state && state.personalizationData) || window.personalizationData || null;
  }

  function isPlaceholderUrl(url) {
    if (!url || typeof url !== 'string') return true;
    if (PLACEHOLDER_IMAGE_RE.test(url)) return true;
    if (/images\.printify\.com\/mockup\/[^/]+\/[^/]+\/[^/]+\/sherpa-fleece-blanket/i.test(url)) return true;
    return false;
  }

  function isUsableImageUrl(url) {
    if (!url || typeof url !== 'string') return '';
    url = forceFiftyBySixtyUrl(url.trim());
    if (isPlaceholderUrl(url)) return '';
    if (url.indexOf('data:image') === 0 || url.indexOf('blob:') === 0) return url;
    if (!/^https?:\/\//i.test(url) && url.indexOf('//') !== 0) return '';
    if (/favicon|sprite|dummy|avatar|icon[-_./]/i.test(url)) return '';
    if (/\.(jpe?g|png|webp|gif)(\?|$)/i.test(url)) return url;
    if (/printify|personalize\.at|pfy-|imgix|images\.|cdn\.shopify|mockup|preview/i.test(url)) return url;
    return '';
  }

  function extractImageUrl(value, depth) {
    depth = depth || 0;
    if (!value || depth > 5) return '';
    if (typeof value === 'string') return isUsableImageUrl(value);
    if (Array.isArray(value)) {
      for (var i = 0; i < value.length; i++) {
        var found = extractImageUrl(value[i], depth + 1);
        if (found) return found;
      }
      return '';
    }
    if (typeof value !== 'object') return '';
    var keys = [
      'imageUrl',
      'image_url',
      'mockupUrl',
      'mockup_url',
      'previewUrl',
      'preview_url',
      'displayUrl',
      'fileUrl',
      'url',
      'src',
      'image',
      'images',
      'files',
      'file',
      'data',
    ];
    for (var k = 0; k < keys.length; k++) {
      if (value[keys[k]]) {
        var nested = extractImageUrl(value[keys[k]], depth + 1);
        if (nested) return nested;
      }
    }
    return '';
  }

  function pushUniqueUrl(urls, url) {
    url = isUsableImageUrl(forceFiftyBySixtyUrl(url));
    if (!url || urls.indexOf(url) !== -1) return;
    urls.push(url);
  }

  function collectImageUrls(value, depth, urls) {
    depth = depth || 0;
    urls = urls || [];
    if (!value || depth > 6) return urls;
    if (typeof value === 'string') {
      pushUniqueUrl(urls, value);
      return urls;
    }
    if (Array.isArray(value)) {
      value.forEach(function (item) {
        collectImageUrls(item, depth + 1, urls);
      });
      return urls;
    }
    if (typeof value !== 'object') return urls;
    var preferred = [
      'mockupUrl',
      'mockup_url',
      'previewUrl',
      'preview_url',
      'displayUrl',
      'imageUrl',
      'image_url',
      'images',
      'mockups',
      'previews',
      'files',
      'previewImages',
      'preview_images',
      'productImages',
      'product_images',
      'renderedImages',
      'personalizedImages',
      'displayImages',
      'imageUrls',
      'mockupImages',
      'mockup_images',
    ];
    preferred.forEach(function (key) {
      if (value[key]) collectImageUrls(value[key], depth + 1, urls);
    });
    Object.keys(value).forEach(function (key) {
      if (preferred.indexOf(key) !== -1) return;
      if (key === 'url' || key === 'src' || key === 'image' || key === 'file' || key === 'fileUrl' || key === 'data') {
        collectImageUrls(value[key], depth + 1, urls);
      }
    });
    return urls;
  }

  function hasPersonalization() {
    var data = personalizationData();
    return Boolean(data && (extractImageUrl(data) || data.personalizationId || data.personalization_id));
  }

  function personalizationImage() {
    return personalizationImages()[0] || '';
  }

  function previewUrlForCart() {
    var url = lastPreviewUrl || personalizationImage() || '';
    try {
      if (!url) url = sessionStorage.getItem('pupprint_preview') || '';
    } catch (err) {}
    url = isUsableImageUrl(url);
    if (!url) return '';
    if (url.indexOf('data:') === 0 || url.indexOf('blob:') === 0) return '';
    if (PLACEHOLDER_IMAGE_RE.test(url)) return '';
    if (isPlaceholderUrl(url)) return '';
    if (url.indexOf('//') === 0) url = window.location.protocol + url;
    if (url.length > 250) url = url.split('?')[0];
    if (url.length > 250) return '';
    return url;
  }

  function upsertHiddenInput(form, name, value) {
    var input = Array.prototype.find.call(form.querySelectorAll('input'), function (el) {
      return el.name === name;
    });
    if (!value) {
      if (input) input.parentNode.removeChild(input);
      return;
    }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  }

  function syncPreviewProperty() {
    var url = previewUrlForCart();
    try {
      if (url) sessionStorage.setItem('pupprint_preview', url);
      else sessionStorage.removeItem('pupprint_preview');
    } catch (err) {}
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      upsertHiddenInput(form, 'properties[_Preview]', url);
    });
  }

  function attachPreviewToBody(body) {
    var url = previewUrlForCart();
    if (!url || !body) return body;
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      if (!body.get('properties[_Preview]')) body.append('properties[_Preview]', url);
      return body;
    }
    if (typeof body === 'string') {
      if (body.indexOf('_Preview') !== -1) return body;
      try {
        var json = JSON.parse(body);
        if (json.items && json.items.length) {
          json.items.forEach(function (item) {
            item.properties = item.properties || {};
            if (!item.properties._Preview) item.properties._Preview = url;
          });
        } else {
          json.properties = json.properties || {};
          if (!json.properties._Preview) json.properties._Preview = url;
        }
        return JSON.stringify(json);
      } catch (err) {
        return body + '&' + encodeURIComponent('properties[_Preview]') + '=' + encodeURIComponent(url);
      }
    }
    return body;
  }

  function hookCartAdd() {
    if (window.__pupprintCartHooked || typeof window.fetch !== 'function') return;
    window.__pupprintCartHooked = true;
    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/add/i.test(url)) {
          init = init ? Object.assign({}, init) : {};
          if (init.body) init.body = attachPreviewToBody(init.body);
        }
      } catch (err) {}
      return originalFetch.apply(this, arguments);
    };
  }

  function rememberOriginal(img) {
    if (!img || img.dataset.originalSrc) return;
    img.dataset.originalSrc = img.getAttribute('src') || img.src || '';
  }

  function galleryImageSrc(img) {
    if (!img) return '';
    return img.currentSrc || img.src || img.getAttribute('data-src') || img.dataset.currentSrc || '';
  }

  function isOwnPreview(img) {
    return Boolean(img && img.closest('.pupprint-preview-slide, .pupprint-preview-thumb, .pupprint-mockup-slide, .pupprint-mockup-thumb, .pupprint-pdp-video-slide, .pupprint-pdp-video-thumb'));
  }

  function findReplacedGalleryImages() {
    var urls = [];
    document.querySelectorAll('.product__media-list img, .thumbnail-list img').forEach(function (img) {
      if (isOwnPreview(img)) return;
      var src = galleryImageSrc(img);
      if (!src) return;
      if (img.dataset.originalSrc && src !== img.dataset.originalSrc) pushUniqueUrl(urls, src);
      else if (img.dataset.currentSrc && img.dataset.currentSrc !== (img.dataset.originalSrc || '')) {
        pushUniqueUrl(urls, img.dataset.currentSrc);
      }
    });
    return urls;
  }

  function findReplacedGalleryImage() {
    return findReplacedGalleryImages()[0] || '';
  }

  function catalogMockupUrl(mockupId) {
    return (
      'https://images.printify.com/mockup/' +
      PRINTIFY_PRODUCT_ID +
      '/' +
      PRINTIFY_VARIANT_50 +
      '/' +
      mockupId +
      '/sherpa-fleece-blanket.jpg'
    );
  }

  function knownMockupId(id) {
    return PRINTIFY_MOCKUP_IDS.indexOf(String(id || '')) !== -1;
  }

  function sizeOnlyQuery(query) {
    var match = String(query || '').match(/[?&]size=([^&]+)/i);
    return match ? '?size=' + match[1] : '';
  }

  function withQueryParam(query, key, value) {
    query = String(query || '');
    var re = new RegExp('([?&])' + key + '=[^&]*', 'i');
    if (re.test(query)) return query.replace(re, '$1' + key + '=' + encodeURIComponent(value));
    if (!query) return '?' + key + '=' + encodeURIComponent(value);
    return query + (query.indexOf('?') === -1 ? '?' : '&') + key + '=' + encodeURIComponent(value);
  }

  function parsePersonalizedPreview(url) {
    var match = String(url || '').match(
      /^(https?:\/\/[^/?#]+(?:\/api)?\/personalisation\/product\/([^/]+)\/preview\/)([^/?#]+)(\?[^#]*)?/i
    );
    if (!match) return null;
    return { prefix: match[1], productId: match[2], mockupId: match[3], query: match[4] || '' };
  }

  function parseMockupCdn(url) {
    var raw = String(url || '');
    var match = raw.match(
      /^(https?:\/\/(?:images|images-api)\.printify\.com)\/mockup\/([^/]+)\/(\d+)\/(\d+)\/([^/?#]+)(\?[^#]*)?/i
    );
    if (match) {
      return {
        origin: match[1],
        productId: match[2],
        variantId: match[3],
        mockupId: match[4],
        file: match[5],
        query: match[6] || '',
      };
    }
    match = raw.match(
      /^(https?:\/\/pfy-prod-automaton-cache\.s3[^/]+)\/mockup\/\d+\/([^/]+)\/(\d+)\/(\d+)\/([^/?#]+)(\?[^#]*)?/i
    );
    if (!match) return null;
    return {
      origin: 'https://images.printify.com',
      productId: match[2],
      variantId: match[3],
      mockupId: match[4],
      file: match[5],
      query: match[6] || '',
      automaton: true,
    };
  }

  function cdnMockupUrl(parsed, mockupId, variantId, query) {
    return (
      parsed.origin +
      '/mockup/' +
      parsed.productId +
      '/' +
      variantId +
      '/' +
      mockupId +
      '/' +
      parsed.file +
      (query || '')
    );
  }

  function forceFiftyBySixtyUrl(url) {
    if (!url || typeof url !== 'string') return url;
    var parsed = parseMockupCdn(url);
    if (parsed && !parsed.automaton && String(parsed.variantId) !== PRINTIFY_VARIANT_50) {
      url = cdnMockupUrl(parsed, parsed.mockupId, PRINTIFY_VARIANT_50, parsed.query);
    }
    return url;
  }

  function currentPersonalizationId() {
    var data = personalizationData() || {};
    var id = lastPersonalizationId || data.personalizationId || data.personalization_id || '';
    if (!id) {
      var input = document.querySelector('input[name="properties[Personalization ID]"]');
      if (input && input.value) id = input.value;
    }
    if (!id) {
      try {
        id = sessionStorage.getItem('pupprint_pid') || '';
      } catch (err) {}
    }
    return String(id || '').trim();
  }

  function keepPidOnForms() {
    var pid = currentPersonalizationId();
    if (pid) lastPersonalizationId = pid;
    try {
      if (pid) sessionStorage.setItem('pupprint_pid', pid);
    } catch (err) {}
    if (!pid) return;
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      upsertHiddenInput(form, 'properties[Personalization ID]', pid);
    });
  }

  function parsePidFromUrl(url) {
    var match = String(url || '').match(/\/personalisation\/(?!product\/)([^/?#]+)\/preview\//i);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function previewApiUrl(pid, mockupId) {
    if (!pid) return '';
    return (
      'https://personalize.at/api/personalisation/' +
      encodeURIComponent(pid) +
      '/preview/' +
      mockupId +
      '?size=1024'
    );
  }

  function skipMockupId(heroUrl) {
    var parsedCdn = parseMockupCdn(heroUrl);
    if (parsedCdn) return String(parsedCdn.mockupId);
    var pidPreview = String(heroUrl || '').match(/\/preview\/([^/?#]+)/i);
    if (pidPreview) return String(pidPreview[1]);
    return '439';
  }

  function extraRenderGroups(heroUrl) {
    var groups = [];
    var pid = currentPersonalizationId() || parsePidFromUrl(heroUrl);
    var parsedCdn = parseMockupCdn(heroUrl);
    var parsedPreview = parsePersonalizedPreview(heroUrl);
    var parsedPidPreview = String(heroUrl || '').match(
      /^(https?:\/\/[^/?#]+(?:\/api)?\/personalisation\/(?!product\/)[^/?#]+\/preview\/)([^/?#]+)(\?[^#]*)?/i
    );
    var skipId = skipMockupId(heroUrl);
    PRINTIFY_MOCKUPS.forEach(function (mockup) {
      if (String(mockup.id) === skipId) return;
      var candidates = [];
      function add(url) {
        url = String(url || '').trim();
        if (!url || isPlaceholderUrl(url) || candidates.indexOf(url) !== -1) return;
        candidates.push(url);
      }
      if (pid) add(previewApiUrl(pid, mockup.id));
      if (parsedPidPreview) add(parsedPidPreview[1] + mockup.id + (parsedPidPreview[3] || '?size=1024'));
      if (parsedCdn && !parsedCdn.automaton) {
        var variantIds = [String(parsedCdn.variantId)];
        if (variantIds.indexOf(PRINTIFY_VARIANT_50) === -1) variantIds.push(PRINTIFY_VARIANT_50);
        variantIds.forEach(function (variantId) {
          add(cdnMockupUrl(parsedCdn, mockup.id, variantId, ''));
          add(cdnMockupUrl(parsedCdn, mockup.id, variantId, sizeOnlyQuery(parsedCdn.query)));
        });
      }
      if (parsedPreview) {
        add(parsedPreview.prefix + mockup.id + (parsedPreview.query || '?size=1024'));
      }
      if (candidates.length) groups.push(candidates);
    });
    return groups;
  }

  function extraCandidateGroups(heroUrl) {
    return extraRenderGroups(heroUrl);
  }

  function firstExtraGroups(urls) {
    var list = urls || [];
    for (var i = 0; i < list.length; i++) {
      var groups = extraCandidateGroups(list[i]);
      if (groups.length) return groups;
    }
    return [];
  }

  function expandPersonalizedUrls(urls) {
    var out = [];
    (urls || []).forEach(function (url) {
      pushUniqueUrl(out, url);
    });
    extraCandidateGroups(out[0] || '').forEach(function (group) {
      group.forEach(function (url) {
        pushUniqueUrl(out, url);
      });
    });
    return out.filter(function (url) {
      return Boolean(isUsableImageUrl(url));
    });
  }

  function sameImageUrl(a, b) {
    function norm(value) {
      value = String(value || '').split('#')[0];
      try {
        var parsed = new URL(value, window.location.href);
        return parsed.origin + parsed.pathname;
      } catch (err) {
        return value.split('?')[0];
      }
    }
    return Boolean(a && b && norm(a) === norm(b));
  }

  function probeImageUrl(url) {
    return new Promise(function (resolve) {
      url = isUsableImageUrl(url);
      if (!url) return resolve('');
      var img = new Image();
      img.onload = function () {
        if ((img.naturalWidth || 0) < 16 || (img.naturalHeight || 0) < 16) return resolve('');
        resolve(url);
      };
      img.onerror = function () {
        resolve('');
      };
      window.setTimeout(function () {
        resolve('');
      }, 4000);
      img.src = url;
    });
  }

  function firstWorkingUrl(candidates) {
    var list = (candidates || []).filter(Boolean);
    if (!list.length) return Promise.resolve('');
    return Promise.all(list.map(probeImageUrl)).then(function (results) {
      for (var i = 0; i < results.length; i++) {
        if (results[i]) return results[i];
      }
      return '';
    });
  }

  function keepWorkingGroups(groups, done) {
    if (!groups || !groups.length) return done([]);
    Promise.all(groups.map(firstWorkingUrl)).then(function (results) {
      done(results.filter(Boolean));
    });
  }

  function keepWorkingUrls(urls, done) {
    firstWorkingUrl(urls).then(function (url) {
      done(url ? [url] : []);
    });
  }

  function catalogExtraUrls() {
    return PRINTIFY_MOCKUPS.slice(1).map(function (mockup) {
      return catalogMockupUrl(mockup.id);
    });
  }

  function personalizationImages(extra) {
    var urls = [];
    collectImageUrls(extra, 0, urls);
    collectImageUrls(personalizationData(), 0, urls);
    findReplacedGalleryImages().forEach(function (url) {
      pushUniqueUrl(urls, url);
    });
    lastPreviewUrls.forEach(function (url) {
      pushUniqueUrl(urls, url);
    });
    pushUniqueUrl(urls, lastPreviewUrl);
    return expandPersonalizedUrls(urls);
  }

  function isFiftySixtyValue(value) {
    return /50/.test(value || '') && /60/.test(value || '') && !/30/.test(value || '') && !/80/.test(value || '');
  }

  function sizeKeyFromValue(value) {
    var text = String(value || '');
    if (/30/.test(text) && /40/.test(text)) return '30x40';
    if (/60/.test(text) && /80/.test(text)) return '60x80';
    if (/50/.test(text) && /60/.test(text)) return '50x60';
    return '';
  }

  function syncSizeGuide(value) {
    var key = sizeKeyFromValue(value || currentSizeValue()) || '50x60';
    document.querySelectorAll('.pupprint-size-guide [data-size]').forEach(function (node) {
      node.classList.toggle('is-selected', node.getAttribute('data-size') === key);
    });
  }

  function selectSizeByKey(key) {
    if (!key) return false;
    var radios = document.querySelectorAll('variant-selects input[type="radio"], .product-form__input input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (sizeKeyFromValue(radios[i].value || '') === key && !radios[i].checked) {
        radios[i].click();
        return true;
      }
    }
    return false;
  }

  function hookSizeGuide() {
    document.querySelectorAll('.pupprint-size-guide [data-size]').forEach(function (node) {
      if (node.__pupprintSizeHooked) return;
      node.__pupprintSizeHooked = true;
      node.addEventListener('click', function () {
        selectSizeByKey(node.getAttribute('data-size'));
        syncSizeGuide();
      });
    });
    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !target.matches) return;
      if (target.matches('variant-selects input[type="radio"], .product-form__input input[type="radio"]')) {
        syncSizeGuide(target.value);
        persistPidNow();
        schedulePersistPhoto(800);
        syncHeaderProductLinks();
      }
    });
    document.addEventListener('variant:change', function () {
      syncSizeGuide();
      persistPhotoAcrossSize();
      syncHeaderProductLinks();
    });
    if (typeof subscribe === 'function') {
      subscribe(typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS.variantChange : 'variant-change', function () {
        syncSizeGuide();
        persistPhotoAcrossSize();
        syncHeaderProductLinks();
      });
    }
    syncSizeGuide();
    syncHeaderProductLinks();
  }

  function currentSizeValue() {
    var radios = document.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].checked) return radios[i].value || '';
    }
    return '';
  }

  function selectSizeValue(value) {
    if (!value) return false;
    var radios = document.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if ((radios[i].value || '') === value && !radios[i].checked) {
        radios[i].click();
        return true;
      }
    }
    return false;
  }

  function selectFiftySixtySize() {
    var radios = document.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (isFiftySixtyValue(radios[i].value || '') && !radios[i].checked) {
        radios[i].click();
        return true;
      }
    }
    return false;
  }

  var persistPhotoTimer = 0;
  function persistPidNow() {
    if (!lastPreviewUrl && !currentPersonalizationId()) return;
    keepPidOnForms();
    syncPreviewProperty();
    syncBuyUi(true);
  }

  function persistPhotoAcrossSize() {
    persistPidNow();
    var urls = lastPreviewUrls.length > 1 ? lastPreviewUrls : lastPreviewUrl;
    if (!urls) return;
    ignorePrintifyRestore = true;
    window.clearTimeout(persistPhotoTimer);
    keepPidOnForms();
    showPreview(urls);
    persistPhotoTimer = window.setTimeout(function () {
      keepPidOnForms();
      syncPreviewProperty();
      showPreview(urls);
      syncBuyUi(true);
      ignorePrintifyRestore = false;
    }, 60);
    window.setTimeout(function () {
      if (hasPhotoForUi()) syncBuyUi(true);
    }, 400);
    window.setTimeout(function () {
      if (hasPhotoForUi()) syncBuyUi(true);
    }, 1200);
  }

  function schedulePersistPhoto(delay) {
    persistPidNow();
    window.clearTimeout(persistPhotoTimer);
    persistPhotoTimer = window.setTimeout(function () {
      persistPhotoAcrossSize();
    }, delay || 800);
  }

  function restoreCartSize() {
    if (!sizeBeforePersonalize || isFiftySixtyValue(sizeBeforePersonalize)) return;
    ignorePrintifyRestore = true;
    selectSizeValue(sizeBeforePersonalize);
    window.setTimeout(function () {
      keepPidOnForms();
      if (lastPreviewUrl) showPreview(lastPreviewUrls.length > 1 ? lastPreviewUrls : lastPreviewUrl);
      ignorePrintifyRestore = false;
    }, 350);
  }

  // The homepage card has no uploader. Select locally instead of simulating a
  // click, which fetches/replaces the card and can focus it below the fold.
  function initializeHomeSize() {
    var data = document.querySelector('[data-pupprint-home-variants]');
    if (!data) return false;
    var card = data.closest('product-info');
    if (!card) return false;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (error) { return false; }
    var radios = card.querySelectorAll('variant-selects input[type="radio"]');
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    var money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency: currency});
    function apply(variant) {
      if (!variant) return;
      radios.forEach(function (radio) { radio.checked = radio.value === variant.option1; });
      card.querySelectorAll('form input[name="id"]').forEach(function (input) { input.value = variant.id; input.dispatchEvent(new Event('change', {bubbles:true})); });
      var selected = card.querySelector('[data-selected-variant]');
      if (selected) selected.textContent = JSON.stringify(variant);
      var price = card.querySelector('[id^="price-"]');
      if (price) {
        var compare = variant.compare_at_price || ({'45787807907949':7900,'45787807940717':9900,'45787807973485':12900})[variant.id];
        price.querySelectorAll('.price__regular .price-item--regular, .price-item--sale').forEach(function (node) { node.textContent = money.format(variant.price / 100); });
        price.querySelectorAll('.price__sale .price-item--regular').forEach(function (node) { node.textContent = money.format((compare || variant.price) / 100); });
        var priceBox = price.querySelector('.price');
        if (priceBox) { priceBox.classList.toggle('price--on-sale', compare > variant.price); priceBox.classList.toggle('price--sold-out', !variant.available); }
      }
      var picker = card.querySelector('variant-selects');
      if (picker) picker.dataset.selectedPriceAmount = (variant.price / 100).toFixed(2);
      card.querySelectorAll('a[href*="/products/sherpa-fleece-blanket"]').forEach(function (link) {
        var url = new URL(link.href, location.href); url.searchParams.set('variant', variant.id);
        link.setAttribute('href', url.pathname + url.search + url.hash);
      });
      var callout = card.querySelector('.pupprint-home-upload .pupprint-callout p');
      if (callout) {
        var heading = document.createElement('strong'); heading.textContent = 'Upload the photo first.';
        callout.replaceChildren(heading, document.createTextNode(' ' + variant.option1 + ' is selected. Upload a JPEG or PNG on the product page and preview before you pay.'));
      }
      syncSizeGuide(variant.option1);
      syncHeaderProductLinks();
    }
    var requested = new URLSearchParams(location.search).get('variant') || '45787807940717';
    apply(variants.find(function (variant) { return String(variant.id) === requested; }) || variants.find(function (variant) { return String(variant.id) === '45787807940717'; }));
    card.addEventListener('change', function (event) {
      if (!event.target.matches('variant-selects input[type="radio"]')) return;
      event.stopImmediatePropagation();
      apply(variants.find(function (variant) { return variant.option1 === event.target.value; }));
    }, true);
    return true;
  }

  function selectHeroSize() {
    if (/[?&]variant=/.test(window.location.search || '')) return false;
    return selectFiftySixtySize();
  }

  function isBlanketPath(pathname) {
    return /\/products\/(sherpa-fleece-blanket|custom-dog-photo-blanket)\/?$/i.test(pathname || '');
  }

  function currentVariantId() {
    var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (input && input.value) return String(input.value);
    var match = String(window.location.search || '').match(/[?&]variant=(\d+)/);
    return match ? match[1] : '';
  }

  function syncHeaderProductLinks() {
    var id = currentVariantId();
    if (!id) return;
    document.querySelectorAll('a[href*="/products/sherpa-fleece-blanket"], a[href*="/products/custom-dog-photo-blanket"]').forEach(function (link) {
      if (!link.closest('.pupprint-header, .pupprint-announce')) return;
      var url;
      try {
        url = new URL(link.getAttribute('href') || link.href, window.location.href);
      } catch (err) {
        return;
      }
      if (!isBlanketPath(url.pathname)) return;
      url.searchParams.set('variant', id);
      link.setAttribute('href', url.pathname + url.search + url.hash);
    });
  }

  function personalizePageUrl() {
    var link = document.querySelector('a[href*="#personalize"]');
    if (link && link.getAttribute('href')) return link.href;
    return '/products/sherpa-fleece-blanket#personalize';
  }

  function openPersonalize() {
    if (modalVisible()) return true;
    var button = personalizeButton();
    if (button) {
      allowPersonalizeClick = true;
      button.click();
      allowPersonalizeClick = false;
      return true;
    }
    if (!/\/products\//i.test(window.location.pathname)) {
      window.location.href = personalizePageUrl();
      return true;
    }
    return false;
  }

  function fiftySixtyOptionValue() {
    var radios = document.querySelectorAll('variant-selects input[type="radio"], .product-form__input input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (isFiftySixtyValue(radios[i].value || '')) return radios[i].value;
    }
    return '50" \u00d7 60"';
  }

  function pinPrintifyIframeSrc(src) {
    if (!src || src.indexOf('personalize.at') === -1) return src;
    try {
      var url = new URL(src, window.location.href);
      var size = fiftySixtyOptionValue();
      var current = url.searchParams.get('options[Size]') || '';
      var sku = url.searchParams.get('sku') || '';
      var needsSize = !isFiftySixtyValue(current);
      var needsSku = Boolean(PRINTIFY_SKU_50 && sku && sku !== PRINTIFY_SKU_50);
      if (!needsSize && !needsSku) return src;
      if (needsSize) url.searchParams.set('options[Size]', size);
      if (needsSku) url.searchParams.set('sku', PRINTIFY_SKU_50);
      return url.toString();
    } catch (err) {
      return src;
    }
  }

  function hookPrintifyIframes() {
    document.querySelectorAll('iframe').forEach(function (frame) {
      var src = frame.getAttribute('src') || '';
      if (src.indexOf('personalize.at') === -1) return;
      var next = pinPrintifyIframeSrc(src);
      if (next && next !== src) frame.setAttribute('src', next);
    });
  }

  function watchPrintifyIframes() {
    if (document.body.__pupprintIframeWatch) return;
    document.body.__pupprintIframeWatch = true;
    var observer = new MutationObserver(function () {
      hookPrintifyIframes();
    });
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['src'],
    });
  }

  function tryOpen(attempts) {
    if (window.location.hash !== HASH) return;
    if (!sizeBeforePersonalize) sizeBeforePersonalize = currentSizeValue();
    window.setTimeout(function () {
      if (openPersonalize() || attempts <= 0) return;
      window.setTimeout(function () {
        tryOpen(attempts - 1);
      }, 250);
    }, 0);
  }

  function startOpen() {
    tryOpen(40);
  }

  function previewMarkup() {
    return (
      '<div class="product-media-container media-type-image global-media-settings gradient constrain-height pupprint-preview">' +
        '<div class="product__media media">' +
          '<img class="pupprint-preview__img" alt="' + PREVIEW_ALT + '" width="1200" height="1200">' +
        '</div>' +
        '<p class="pupprint-preview__badge">Your photo</p>' +
      '</div>'
    );
  }

  function ensurePreviewSlide(list) {
    var slide = list.querySelector('.pupprint-preview-slide');
    if (slide) return slide;
    slide = document.createElement('li');
    slide.className = 'product__media-item grid__item slider__slide is-active product__media-item--full pupprint-preview-slide';
    slide.setAttribute('data-media-id', 'pupprint-preview');
    slide.innerHTML = previewMarkup();
    list.insertBefore(slide, list.firstChild);
    return slide;
  }

  function mediaIdPrefix(list) {
    var item = list && list.querySelector('[data-media-id]');
    var id = item ? item.getAttribute('data-media-id') : '';
    return id ? id.replace(/-(pupprint-video|pupprint-preview|pupprint-mockup-\d+|\d+)$/, '') : '';
  }

  function slideMediaId(list, suffix) {
    var prefix = mediaIdPrefix(list);
    return prefix ? prefix + '-' + suffix : suffix;
  }

  function bindThumb(thumb) {
    if (!thumb || thumb.__pupprintBound) return;
    var button = thumb.querySelector('button');
    if (!button) return;
    thumb.__pupprintBound = true;
    button.addEventListener('click', function () {
      var id = thumb.getAttribute('data-target');
      if (id) pickedMediaId = id;
      document.querySelectorAll('media-gallery').forEach(function (gallery) {
        if (typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(id, false);
      });
    });
  }

  function applySampleProductImage() {
    if (!SAMPLE_PRODUCT_IMAGE) return;
    document.querySelectorAll('.product__media-list img, .thumbnail-list img').forEach(function (img) {
      if (img.closest('.pupprint-mockup-slide, .pupprint-mockup-thumb, .pupprint-preview-slide, .pupprint-preview-thumb')) return;
      var src = img.getAttribute('src') || img.currentSrc || '';
      var srcset = img.getAttribute('srcset') || '';
      if (!PLACEHOLDER_IMAGE_RE.test(src) && !PLACEHOLDER_IMAGE_RE.test(srcset)) return;
      setImageUrl(img, SAMPLE_PRODUCT_IMAGE, img.alt || 'Custom dog photo blanket');
    });
  }

  function ensurePreviewThumb(list) {
    var slide = document.querySelector('.pupprint-preview-slide');
    var target = (slide && slide.getAttribute('data-media-id')) || slideMediaId(list, 'pupprint-preview');
    var thumb = list.querySelector('.pupprint-preview-thumb');
    if (thumb) {
      thumb.setAttribute('data-target', target);
      bindThumb(thumb);
      return thumb;
    }
    thumb = document.createElement('li');
    thumb.className = 'thumbnail-list__item slider__slide pupprint-preview-thumb';
    thumb.setAttribute('data-target', target);
    thumb.innerHTML =
      '<button type="button" class="thumbnail global-media-settings global-media-settings--no-shadow" aria-label="Your photo" aria-current="true">' +
        '<img alt="" width="80" height="80">' +
      '</button>';
    list.insertBefore(thumb, list.firstChild);
    bindThumb(thumb);
    return thumb;
  }

  function showConfirm() {
    var note = document.querySelector('.pupprint-callout p');
    if (note) {
      note.innerHTML = '<strong>Photo added.</strong> This is the blanket you will get. Change the photo if you want, then add it to cart.';
    }
    if (document.querySelector('.pupprint-photo-ready')) return;
    var form = document.querySelector('.product-form__buttons');
    if (!form) return;
    var ready = document.createElement('p');
    ready.className = 'pupprint-photo-ready';
    ready.textContent = 'Preview updated with your photo.';
    form.parentNode.insertBefore(ready, form);
  }

  function hasPhotoForUi() {
    return Boolean(lastPreviewUrl || lastPersonalizationId || currentPersonalizationId() || hasPersonalization());
  }

  function setControlLabel(node, label) {
    if (!node) return;
    var span = node.querySelector('span:not(.loading__spinner)');
    if (span && !span.querySelector('svg')) {
      if (span.textContent !== label) span.textContent = label;
      return;
    }
    if ((node.textContent || '').replace(/\s+/g, ' ').trim() !== label) node.textContent = label;
  }

  function personalizeButtons() {
    var found = [];
    function add(node) {
      if (!node || found.indexOf(node) !== -1) return;
      if (node.closest && node.closest('[name="add"], .product-form__submit, .pupprint-sticky, cart-items, cart-drawer-items, quantity-input, form[action="/cart"]')) return;
      found.push(node);
    }
    document.querySelectorAll('button[id^="personalize-button"], button.personalize-button, .personalize-container button').forEach(add);
    document.querySelectorAll('button, [role="button"]').forEach(function (node) {
      var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (/upload your dog|change photo/i.test(text)) add(node);
    });
    return found;
  }

  function syncBuyUi(personalized) {
    if (personalized == null) personalized = hasPhotoForUi();
    document.querySelectorAll('.product-form__submit').forEach(function (button) {
      button.classList.toggle('button--primary', personalized);
      button.classList.toggle('button--secondary', !personalized);
    });
    document.querySelectorAll('.product-form__submit span').forEach(function (span) {
      if (span.querySelector('svg, .loading__spinner')) return;
      span.textContent = 'Add to cart';
    });
    document.querySelectorAll('.pupprint-sticky a.button').forEach(function (link) {
      link.textContent = personalized ? 'Add to cart' : 'Upload a photo';
      link.setAttribute('href', personalized ? '#add-to-cart' : '#personalize');
    });
    var uploadLabel = personalized ? 'Change photo' : 'Upload your dog’s photo';
    personalizeButtons().forEach(function (button) {
      button.classList.toggle('pupprint-change-photo', personalized);
      setControlLabel(button, uploadLabel);
    });
  }

  function watchPersonalizeLabel() {
    if (document.body.__pupprintLabelWatch) return;
    document.body.__pupprintLabelWatch = true;
    var timer = 0;
    var observer = new MutationObserver(function () {
      if (!hasPhotoForUi()) return;
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        syncBuyUi(true);
      }, 40);
    });
    observer.observe(document.body, { subtree: true, childList: true, characterData: true });
  }

  function resetSliders() {
    document.querySelectorAll('slider-component').forEach(function (slider) {
      if (typeof slider.resetPages === 'function') slider.resetPages();
    });
  }

  function videoNodes() {
    return document.querySelectorAll('.pupprint-pdp-video-slide, .pupprint-pdp-video-thumb, [data-target$="pupprint-video"]');
  }

  function setVideoHidden(hidden) {
    videoNodes().forEach(function (el) {
      if (hidden) {
        el.hidden = true;
        el.setAttribute('hidden', '');
        el.classList.remove('is-active');
      } else {
        el.hidden = false;
        el.removeAttribute('hidden');
      }
    });
    document.querySelectorAll('.pupprint-pdp-video').forEach(function (video) {
      try {
        if (hidden) video.pause();
        else if (video.paused) video.play();
      } catch (err) {}
    });
  }

  function hideMockupPair(item) {
    if (!item) return;
    var id = item.getAttribute('data-media-id') || item.getAttribute('data-target') || '';
    var mockup = id.match(/pupprint-mockup-\d+/);
    item.hidden = true;
    item.setAttribute('hidden', '');
    if (!mockup) return;
    document.querySelectorAll('[data-media-id$="' + mockup[0] + '"], [data-target$="' + mockup[0] + '"]').forEach(function (el) {
      el.hidden = true;
      el.setAttribute('hidden', '');
    });
  }

  function setImageUrl(img, imageUrl, alt) {
    if (!img || !imageUrl) return;
    imageUrl = forceFiftyBySixtyUrl(imageUrl);
    rememberOriginal(img);
    if (alt) img.alt = alt;
    img.style.objectFit = 'cover';
    img.onerror = function () {
      var item = img.closest('.pupprint-mockup-slide, .pupprint-mockup-thumb');
      if (item) hideMockupPair(item);
    };
    if (img.src !== imageUrl) {
      img.src = imageUrl;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
    }
    img.dataset.pupprintApplied = imageUrl;
    img.dataset.currentSrc = imageUrl;
  }

  function productImageSlides(list) {
    return Array.prototype.filter.call(list.querySelectorAll('.product__media-item'), function (item) {
      return !item.classList.contains('pupprint-preview-slide') && !item.classList.contains('pupprint-pdp-video-slide');
    });
  }

  function productThumbs(list) {
    return Array.prototype.filter.call(list.querySelectorAll('.thumbnail-list__item'), function (item) {
      return !item.classList.contains('pupprint-preview-thumb') && !item.classList.contains('pupprint-pdp-video-thumb');
    });
  }

  function mockupMarkup() {
    return (
      '<div class="product-media-container media-type-image global-media-settings gradient constrain-height pupprint-preview">' +
        '<div class="product__media media">' +
          '<img class="pupprint-mockup__img" alt="' + PREVIEW_ALT + '" width="1200" height="1200">' +
        '</div>' +
      '</div>'
    );
  }

  function ensureMockupSlides(list, count) {
    var slides = Array.prototype.slice.call(list.querySelectorAll('.pupprint-mockup-slide'));
    var i = slides.length;
    while (i < count) {
      var slide = document.createElement('li');
      slide.className = 'product__media-item grid__item slider__slide product__media-item--full pupprint-mockup-slide';
      slide.setAttribute('data-media-id', slideMediaId(list, 'pupprint-mockup-' + i));
      slide.innerHTML = mockupMarkup();
      list.appendChild(slide);
      slides.push(slide);
      i += 1;
    }
    return slides;
  }

  function ensureThumbnailList() {
    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      var list = gallery.querySelector('.thumbnail-list');
      if (!list) {
        var sid = (gallery.id || '').replace('MediaGallery-', '');
        var slider = document.createElement('slider-component');
        slider.id = 'GalleryThumbnails-' + sid;
        slider.className = 'thumbnail-slider slider-mobile-gutter';
        slider.innerHTML =
          '<ul id="Slider-Thumbnails-' +
          sid +
          '" class="thumbnail-list list-unstyled slider slider--mobile" role="list"></ul>';
        gallery.appendChild(slider);
        list = slider.querySelector('.thumbnail-list');
        if (gallery.elements) gallery.elements.thumbnails = slider;
      } else if (gallery.elements && !gallery.elements.thumbnails) {
        gallery.elements.thumbnails = list.closest('slider-component');
      }
    });
    return document.querySelectorAll('.thumbnail-list');
  }

  function ensureMockupThumbs(list, count) {
    var thumbs = Array.prototype.slice.call(list.querySelectorAll('.pupprint-mockup-thumb'));
    var i = thumbs.length;
    while (i < count) {
      var thumb = document.createElement('li');
      var slide = document.querySelector('[data-media-id$="pupprint-mockup-' + i + '"]');
      var target = (slide && slide.getAttribute('data-media-id')) || slideMediaId(list, 'pupprint-mockup-' + i);
      thumb.className = 'thumbnail-list__item slider__slide pupprint-mockup-thumb';
      thumb.setAttribute('data-target', target);
      thumb.innerHTML =
        '<button type="button" class="thumbnail global-media-settings global-media-settings--no-shadow" aria-label="' +
        PREVIEW_ALT +
        '">' +
          '<img alt="" width="80" height="80">' +
        '</button>';
      thumb.hidden = true;
      thumb.setAttribute('hidden', '');
      list.appendChild(thumb);
      bindThumb(thumb);
      thumbs.push(thumb);
      i += 1;
    }
    return thumbs;
  }

  function applyUrlListToItems(items, urls, alt) {
    items.forEach(function (item, index) {
      var url = urls[index];
      var isMockup =
        item.classList.contains('pupprint-mockup-slide') || item.classList.contains('pupprint-mockup-thumb');
      if (!url) {
        if (isMockup) {
          item.hidden = true;
          item.setAttribute('hidden', '');
        }
        return;
      }
      item.hidden = false;
      item.removeAttribute('hidden');
      var img = item.querySelector('img');
      if (!img) return;
      rememberOriginal(img);
      setImageUrl(img, url, alt);
    });
  }

  function applyUrlsToGallery(urls) {
    var extras = urls.slice(1);
    document.querySelectorAll('.product__media-list').forEach(function (list) {
      var slides = ensureMockupSlides(list, extras.length);
      applyUrlListToItems(slides, extras, PREVIEW_ALT);
      slides.forEach(function (slide) {
        if (!slide.hidden) sizePreviewSlide(slide);
      });
    });
    ensureThumbnailList().forEach(function (list) {
      applyUrlListToItems(ensureMockupThumbs(list, extras.length), extras, '');
      list.querySelectorAll('.thumbnail-list__item').forEach(bindThumb);
    });
  }

  function hideNativeProductImages() {
    document.querySelectorAll('.product__media-item, .thumbnail-list__item').forEach(function (item) {
      if (
        item.classList.contains('pupprint-pdp-video-slide') ||
        item.classList.contains('pupprint-pdp-video-thumb') ||
        item.classList.contains('pupprint-preview-slide') ||
        item.classList.contains('pupprint-preview-thumb') ||
        item.classList.contains('pupprint-mockup-slide') ||
        item.classList.contains('pupprint-mockup-thumb') ||
        item.classList.contains('pupprint-default-slide') ||
        item.classList.contains('pupprint-default-thumb')
      ) {
        return;
      }
      item.hidden = true;
      item.setAttribute('hidden', '');
      item.classList.remove('is-active');
    });
  }

  function stripCatalogMockups() {
    document.querySelectorAll('.pupprint-mockup-slide, .pupprint-mockup-thumb').forEach(function (el) {
      el.remove();
    });
  }

  function hideDefaultStills() {
    document.querySelectorAll('.pupprint-default-slide, .pupprint-default-thumb').forEach(function (el) {
      el.hidden = true;
      el.setAttribute('hidden', '');
      el.style.display = 'none';
      el.classList.remove('is-active');
    });
  }

  function showDefaultStills() {
    document.querySelectorAll('.pupprint-default-slide, .pupprint-default-thumb').forEach(function (el) {
      el.hidden = false;
      el.removeAttribute('hidden');
      el.style.removeProperty('display');
    });
  }

  function hidePlaceholderGalleryItems() {
    hideNativeProductImages();
    hideDefaultStills();
    document.querySelectorAll('.product__media-item, .thumbnail-list__item').forEach(function (item) {
      if (
        item.classList.contains('pupprint-preview-slide') ||
        item.classList.contains('pupprint-preview-thumb') ||
        item.classList.contains('pupprint-pdp-video-slide') ||
        item.classList.contains('pupprint-pdp-video-thumb') ||
        item.classList.contains('pupprint-mockup-slide') ||
        item.classList.contains('pupprint-mockup-thumb')
      ) {
        return;
      }
      item.hidden = true;
      item.setAttribute('hidden', '');
      item.classList.remove('is-active');
    });
  }

  function restoreModalMedia() {
    document.querySelectorAll('.product-media-modal__content').forEach(function (content) {
      content.querySelectorAll('.pupprint-modal-preview').forEach(function (el) {
        el.remove();
      });
      Array.prototype.forEach.call(content.children, function (el) {
        el.hidden = false;
        el.removeAttribute('hidden');
      });
    });
  }

  function syncModalPreviews(urls) {
    urls = (urls || []).filter(function (url) {
      return Boolean(isUsableImageUrl(url));
    });
    document.querySelectorAll('.product-media-modal__content').forEach(function (content) {
      content.querySelectorAll('.pupprint-modal-preview').forEach(function (el) {
        el.remove();
      });
      Array.prototype.forEach.call(content.children, function (el) {
        el.hidden = true;
        el.setAttribute('hidden', '');
      });
      urls.forEach(function (url) {
        var img = document.createElement('img');
        img.className = 'pupprint-modal-preview';
        img.src = url;
        img.alt = PREVIEW_ALT;
        content.appendChild(img);
      });
    });
  }

  function injectCatalogMockups() {
    if (hasPersonalization() || lastPreviewUrl) return;
    hideNativeProductImages();
    stripCatalogMockups();
  }

  function restoreOriginalImages() {
    document.querySelectorAll('img[data-original-src]').forEach(function (img) {
      if (isOwnPreview(img)) return;
      var original = img.dataset.originalSrc;
      if (!original) return;
      img.src = original;
      img.removeAttribute('srcset');
      delete img.dataset.pupprintApplied;
      delete img.dataset.currentSrc;
    });
  }

  function sizePreviewSlide(slide) {
    if (!slide) return;
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    var minH = mobile ? '70vw' : '280px';
    slide.style.removeProperty('display');
    slide.style.minHeight = minH;
    if (mobile) {
      slide.style.display = 'flex';
      slide.style.alignItems = 'stretch';
      slide.style.flex = '0 0 calc(100% - 3rem)';
      slide.style.width = 'calc(100% - 3rem)';
    } else {
      slide.style.removeProperty('align-items');
      slide.style.removeProperty('flex');
      slide.style.removeProperty('width');
    }
    var box = slide.querySelector('.product-media-container, .pupprint-preview');
    if (box) {
      box.style.display = 'block';
      box.style.position = 'relative';
      box.style.width = '100%';
      box.style.maxWidth = '100%';
      box.style.minHeight = minH;
      box.style.aspectRatio = '1 / 1';
      box.style.height = 'auto';
    }
  }

  function showPreview(imageUrl) {
    previewGen += 1;
    var urls = [];
    collectImageUrls(imageUrl, 0, urls);
    collectImageUrls(pendingRenderUrls, 0, urls);
    collectImageUrls(personalizationData(), 0, urls);
    findReplacedGalleryImages().forEach(function (url) {
      pushUniqueUrl(urls, url);
    });
    rememberPersonalizationId(personalizationData());
    imageUrl = urls[0] || extractImageUrl(imageUrl) || personalizationImage() || findReplacedGalleryImage();
    if (!imageUrl) {
      window.setTimeout(function () {
        if (lastPreviewUrl) return;
        var later = findReplacedGalleryImage() || extractImageUrl(personalizationData());
        if (later) showPreview(later);
      }, 400);
      return;
    }
    lastPreviewUrl = imageUrl;
    lastPreviewUrls = [imageUrl];
    keepPidOnForms();
    syncPreviewProperty();
    document.body.classList.add('pupprint-has-photo');
    setVideoHidden(true);
    hidePlaceholderGalleryItems();
    ensureThumbnailList();

    document.querySelectorAll('.product__media-list').forEach(function (list) {
      var slide = ensurePreviewSlide(list);
      slide.hidden = false;
      slide.removeAttribute('hidden');
      list.insertBefore(slide, list.firstChild);
      sizePreviewSlide(slide);
      var wrap = slide.querySelector('.product__media, .media');
      if (wrap) {
        wrap.style.position = 'absolute';
        wrap.style.inset = '0';
        wrap.style.width = '100%';
        wrap.style.height = '100%';
        wrap.style.paddingTop = '0';
      }
      var img = slide.querySelector('.pupprint-preview__img, img');
      if (img) {
        img.style.position = 'absolute';
        img.style.inset = '0';
        img.style.width = '100%';
        img.style.height = '100%';
        img.style.objectFit = 'cover';
        setImageUrl(img, imageUrl, PREVIEW_ALT);
      }
      list.querySelectorAll('.product__media-item').forEach(function (item) {
        item.classList.remove('is-active');
      });
      slide.classList.add('is-active');
    });

    document.querySelectorAll('.thumbnail-list').forEach(function (list) {
      var thumb = ensurePreviewThumb(list);
      thumb.hidden = false;
      thumb.removeAttribute('hidden');
      list.insertBefore(thumb, list.firstChild);
      var img = thumb.querySelector('img');
      if (img) setImageUrl(img, imageUrl, '');
      list.querySelectorAll('.thumbnail').forEach(function (button) {
        button.removeAttribute('aria-current');
      });
      var current = thumb.querySelector('.thumbnail');
      if (current) current.setAttribute('aria-current', 'true');
    });

    document.querySelectorAll('.pupprint-mockup-slide, .pupprint-mockup-thumb').forEach(function (el) {
      el.hidden = true;
      el.setAttribute('hidden', '');
    });
    showConfirm();
    syncBuyUi(true);
    document.querySelectorAll('.product__media-list').forEach(function (list) {
      list.scrollLeft = 0;
    });
    resetSliders();
    document.querySelectorAll('[data-media-id$="pupprint-preview"]').forEach(function (slide) {
      var id = slide.getAttribute('data-media-id');
      if (id) pickedMediaId = id;
    });
    activateGallery('pupprint-preview');
    syncModalPreviews(lastPreviewUrls);
    applyUrlsToGallery(lastPreviewUrls);
    window.setTimeout(function () {
      fillExtraMockups(lastPreviewUrl, previewGen);
    }, 250);
    window.setTimeout(function () {
      if (lastPreviewUrls.length > 1) return;
      fillExtraMockups(lastPreviewUrl, previewGen);
    }, 1200);
  }

  function fillExtraMockups(heroUrl, gen) {
    var groups = extraRenderGroups(heroUrl);
    document.querySelectorAll('.pupprint-preview-slide img').forEach(function (img) {
      extraRenderGroups(img.currentSrc || img.src).forEach(function (group) {
        groups.push(group);
      });
    });
    if (!groups.length) {
      hideDefaultStills();
      return;
    }
    Promise.all(groups.map(firstWorkingUrl)).then(function (results) {
      if (gen !== previewGen) return;
      var extras = [];
      results.forEach(function (url) {
        if (!url || isPlaceholderUrl(url) || sameImageUrl(url, lastPreviewUrl)) return;
        if (extras.indexOf(url) !== -1) return;
        extras.push(url);
      });
      if (!extras.length) {
        hideDefaultStills();
        return;
      }
      lastPreviewUrls = [lastPreviewUrl].concat(extras);
      applyUrlsToGallery(lastPreviewUrls);
      hideDefaultStills();
      syncModalPreviews(lastPreviewUrls);
      syncPreviewProperty();
    });
  }

  function hidePreview() {
    previewGen += 1;
    lastPreviewUrl = '';
    lastPreviewUrls = [];
    lastPersonalizationId = '';
    pickedMediaId = '';
    syncPreviewProperty();
    document.body.classList.remove('pupprint-has-photo');
    restoreOriginalImages();
    restoreModalMedia();
    showDefaultStills();
    document.querySelectorAll('.pupprint-preview-slide').forEach(function (slide) {
      slide.hidden = true;
      slide.classList.remove('is-active');
    });
    document.querySelectorAll('.pupprint-preview-thumb').forEach(function (thumb) {
      thumb.hidden = true;
    });
    document.querySelectorAll('.pupprint-mockup-slide, .pupprint-mockup-thumb').forEach(function (el) {
      el.remove();
    });
    setVideoHidden(false);
    document.querySelectorAll('.pupprint-photo-ready').forEach(function (note) {
      note.remove();
    });
    var note = document.querySelector('.pupprint-callout p');
    if (note) {
      note.innerHTML = '<strong>Upload the photo once.</strong> JPEG or PNG. 50×60 is already selected. Same photo on every size — you do not upload again. Then add to cart, or pick a bigger size.';
    }
    syncBuyUi(false);
    keepDefaultGallery();
  }

  function applyFromState() {
    var urls = personalizationImages();
    if (urls.length) showPreview(urls);
  }

  function galleryMediaId(gallery, suffix) {
    var slide = gallery.querySelector('[data-media-id$="' + suffix + '"]');
    return slide ? slide.getAttribute('data-media-id') : '';
  }

  function activateGallery(suffix) {
    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      var id = galleryMediaId(gallery, suffix);
      if (!id) return;
      var slide = gallery.querySelector('[data-media-id="' + id + '"]');
      if (slide && slide.classList.contains('is-active') && !slide.hidden) return;
      if (slide) {
        gallery.querySelectorAll('.product__media-item').forEach(function (item) {
          item.classList.remove('is-active');
        });
        slide.classList.add('is-active');
        if (gallery.elements && gallery.elements.viewer) {
          gallery.elements.viewer.scrollTo({ left: slide.offsetLeft });
        }
      }
      if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(id, false);
      }
    });
  }

  function hookMediaGallery() {
    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      if (gallery.__pupprintMediaHooked || typeof gallery.setActiveMedia !== 'function') return;
      gallery.__pupprintMediaHooked = true;
      var original = gallery.setActiveMedia.bind(gallery);
      gallery.setActiveMedia = function (mediaId) {
        if (hasPersonalization() || lastPreviewUrl) {
          var slide = gallery.querySelector('[data-media-id="' + mediaId + '"]');
          var allowed =
            slide &&
            (slide.classList.contains('pupprint-preview-slide') ||
              slide.classList.contains('pupprint-mockup-slide'));
          if (!allowed) mediaId = galleryMediaId(gallery, 'pupprint-preview') || mediaId;
        }
        original(mediaId, false);
      };
    });
  }

  function keepDefaultGallery() {
    hookMediaGallery();
    if (hasPersonalization() || lastPreviewUrl) {
      applyFromState();
      return;
    }
    pickedMediaId = '';
    setVideoHidden(false);
    injectCatalogMockups();
    applySampleProductImage();
    showDefaultStills();
    document.querySelectorAll('.product__media-list').forEach(function (list) {
      var preview = list.querySelector('.pupprint-preview-slide');
      var video = list.querySelector('.pupprint-pdp-video-slide');
      if (preview) {
        preview.hidden = true;
        preview.setAttribute('hidden', '');
        preview.classList.remove('is-active');
      }
      if (video) list.insertBefore(video, list.firstChild);
      if (preview) list.insertBefore(preview, video ? video.nextSibling : list.firstChild);
      list.querySelectorAll('.product__media-item').forEach(function (item) {
        item.classList.toggle('is-active', item === video);
      });
    });
    document.querySelectorAll('.thumbnail-list').forEach(function (list) {
      var previewThumb = list.querySelector('.pupprint-preview-thumb');
      var videoThumb = list.querySelector('.pupprint-pdp-video-thumb');
      if (previewThumb) {
        previewThumb.hidden = true;
        previewThumb.setAttribute('hidden', '');
      }
      if (videoThumb) list.insertBefore(videoThumb, list.firstChild);
    });
    document.querySelectorAll('.pupprint-pdp-video').forEach(function (video) {
      try {
        video.muted = true;
        var play = video.play();
        if (play && typeof play.catch === 'function') play.catch(function () {});
      } catch (err) {}
    });
  }

  function rememberPersonalizationId(value) {
    if (!value) return;
    if (typeof value === 'string' || typeof value === 'number') {
      lastPersonalizationId = String(value).trim();
      try {
        if (lastPersonalizationId) sessionStorage.setItem('pupprint_pid', lastPersonalizationId);
      } catch (err) {}
      return;
    }
    if (typeof value !== 'object') return;
    rememberPersonalizationId(value.personalizationId || value.personalization_id);
    if (value.data) rememberPersonalizationId(value.data);
  }

  function hookPrintifyMethod(instance, name) {
    var original = instance[name];
    if (typeof original !== 'function' || original.__pupprintWrapped) return;
    var wrapped = function () {
      var result = original.apply(instance, arguments);
      Array.prototype.forEach.call(arguments, function (arg) {
        rememberPersonalizationId(arg);
        collectImageUrls(arg, 0, pendingRenderUrls);
      });
      if (modalVisible()) return result;
      window.setTimeout(function () {
        showPreview(pendingRenderUrls.concat(personalizationImages()));
      }, 0);
      return result;
    };
    wrapped.__pupprintWrapped = true;
    instance[name] = wrapped;
  }

  function hookPrintify() {
    Object.keys(window).forEach(function (key) {
      if (key.indexOf('personalize_') !== 0) return;
      var instance = window[key];
      if (!instance || instance.__pupprintHooked) return;
      instance.__pupprintHooked = true;

      ['replaceProductImage', 'replaceProductImages', 'updateProductImages', 'setProductImages'].forEach(function (name) {
        hookPrintifyMethod(instance, name);
      });

      var restore = instance.restoreProductImage;
      instance.restoreProductImage = function () {
        if (ignorePrintifyRestore || lastPreviewUrl) {
          keepPidOnForms();
          return;
        }
        hidePreview();
        pendingRenderUrls = [];
        if (typeof restore === 'function') restore.apply(instance, arguments);
      };
    });
  }

  function watchGallerySwaps() {
    if (document.body.__pupprintGalleryWatch) return;
    document.body.__pupprintGalleryWatch = true;
    var observer = new MutationObserver(function (records) {
      if (modalVisible()) return;
      if (!hasPersonalization() && !lastPreviewUrl) return;
      var swapped = false;
      records.forEach(function (record) {
        var target = record.target;
        if (!target || target.tagName !== 'IMG') return;
        if (isOwnPreview(target)) return;
        if (target.closest('.pupprint-default-slide, .pupprint-default-thumb')) return;
        var next = galleryImageSrc(target);
        if (target.dataset.pupprintApplied && target.dataset.pupprintApplied === next) return;
        if (record.attributeName === 'src' || record.attributeName === 'srcset') swapped = true;
      });
      if (swapped) applyFromState();
    });
    observer.observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'srcset', 'data-src', 'data-current-src'],
    });
  }

  function isAddAction(target) {
    if (!target || !target.closest) return false;
    if (target.closest('[name="add"], .product-form__submit')) return true;
    if (target.closest('shop-pay-button, .shopify-payment-button, .shopify-payment-button__button')) return true;
    return false;
  }

  function requirePhoto(event) {
    if (hasPersonalization() || lastPreviewUrl) return false;
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', HASH);
    } else {
      window.location.hash = HASH;
    }
    startOpen();
    return true;
  }

  function closeDesignLightbox() {
    var box = document.getElementById('pupprint-design-lightbox');
    if (!box) return;
    box.hidden = true;
    box.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pupprint-lightbox-open');
  }

  function openDesignLightbox(src, alt) {
    if (!src) return;
    var box = document.getElementById('pupprint-design-lightbox');
    if (!box) {
      box = document.createElement('div');
      box.id = 'pupprint-design-lightbox';
      box.className = 'pupprint-design-lightbox';
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.setAttribute('aria-label', 'Your custom blanket preview');
      box.innerHTML =
        '<button type="button" class="pupprint-design-lightbox__close" aria-label="Close">&times;</button>' +
        '<img class="pupprint-design-lightbox__img" alt="" src="">' +
        '<p class="pupprint-design-lightbox__caption">Your blanket preview</p>';
      document.body.appendChild(box);
      box.addEventListener('click', function (event) {
        if (event.target === box || event.target.closest('.pupprint-design-lightbox__close')) {
          closeDesignLightbox();
        }
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeDesignLightbox();
      });
    }
    box.querySelector('.pupprint-design-lightbox__caption').textContent = alt || 'Your design';
    var img = box.querySelector('.pupprint-design-lightbox__img');
    if (img) {
      img.src = src;
      img.alt = alt || 'Your custom blanket preview';
    }
    box.hidden = false;
    box.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pupprint-lightbox-open');
  }

  document.addEventListener(
    'click',
    function (event) {
      var lightboxTrigger = event.target.closest('[data-pupprint-lightbox]');
      if (lightboxTrigger) {
        event.preventDefault();
        openDesignLightbox(
          lightboxTrigger.getAttribute('data-pupprint-lightbox') || '',
          lightboxTrigger.getAttribute('data-pupprint-lightbox-alt') || ''
        );
        return;
      }

      var cartLink = event.target.closest('a[href$="#add-to-cart"]');
      if (cartLink && (hasPersonalization() || lastPreviewUrl)) {
        event.preventDefault();
        var submit = document.querySelector('.product-form__submit');
        if (submit) submit.click();
        return;
      }

      var link = event.target.closest('a[href*="#personalize"]');
      if (link) {
        var url = new URL(link.href, window.location.href);
        if (url.pathname === window.location.pathname && url.hash === HASH) {
          event.preventDefault();
          if (window.history && window.history.replaceState) {
            window.history.replaceState(null, '', HASH);
          } else {
            window.location.hash = HASH;
          }
          startOpen();
          return;
        }
      }

      var shopLink = event.target.closest(
        'a[href*="/products/sherpa-fleece-blanket"], a[href*="/products/custom-dog-photo-blanket"]'
      );
      if (shopLink && isBlanketPath(window.location.pathname)) {
        var dest;
        try {
          dest = new URL(shopLink.href, window.location.href);
        } catch (err) {
          dest = null;
        }
        if (dest && isBlanketPath(dest.pathname) && dest.hash !== HASH) {
          event.preventDefault();
          var menu = shopLink.closest('details');
          if (menu) menu.removeAttribute('open');
          return;
        }
      }

      if (isAddAction(event.target)) requirePhoto(event);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.matches) return;
      if (!form.matches('[data-type="add-to-cart-form"], form[action*="/cart/add"]')) return;
      if (requirePhoto(event)) return;
      syncPreviewProperty();
    },
    true
  );

  window.addEventListener('message', function (event) {
    if (!event.data) return;
    var type = event.data.type || event.data.event || '';
    if (type === 'PERSONALIZATION_APPLIED') {
      rememberPersonalizationId(event.data);
      collectImageUrls(event.data && event.data.data, 0, pendingRenderUrls);
      collectImageUrls(event.data, 0, pendingRenderUrls);
      window.setTimeout(function () {
        showPreview(pendingRenderUrls.concat([event.data, event.data && event.data.data]));
        keepPidOnForms();
        restoreCartSize();
      }, 200);
      window.setTimeout(syncPreviewProperty, 0);
    }
    if (type === 'CLOSE_PERSONALIZATION_MODAL') {
      if (hasPersonalization() || pendingRenderUrls.length || lastPreviewUrl) {
        window.setTimeout(function () {
          showPreview(pendingRenderUrls.concat(personalizationImages()));
          keepPidOnForms();
          restoreCartSize();
        }, 200);
      } else {
        hidePreview();
      }
    }
  });

  window.addEventListener('hashchange', function () {
    if (window.location.hash === HASH) startOpen();
  });

  function rememberGalleryOriginals() {
    document.querySelectorAll('.product__media-list img, .thumbnail-list img').forEach(function (img) {
      if (!isOwnPreview(img)) rememberOriginal(img);
    });
  }

  function restoreSavedDesign() {
    var pid = '';
    var preview = '';
    try {
      pid = sessionStorage.getItem('pupprint_pid') || '';
      preview = sessionStorage.getItem('pupprint_preview') || '';
    } catch (err) {}
    if (!pid && !preview) return;
    if (pid) {
      lastPersonalizationId = pid;
      keepPidOnForms();
    }
    if (preview) {
      showPreview(preview);
      syncBuyUi(true);
      return;
    }
    if (pid) {
      var apiPreview = previewApiUrl(pid, '439');
      if (apiPreview) {
        showPreview(apiPreview);
        syncBuyUi(true);
      }
    }
  }

  function boot() {
    if (!initializeHomeSize()) selectHeroSize();
    hookSizeGuide();
    syncHeaderProductLinks();
    rememberGalleryOriginals();
    restoreSavedDesign();
    hookHeicFrames();
    hookPrintify();
    hookPrintifyIframes();
    hookMediaGallery();
    hookCartAdd();
    watchGallerySwaps();
    watchPrintifyIframes();
    watchPersonalizeLabel();
    keepDefaultGallery();
    syncPreviewProperty();
    syncBuyUi(hasPhotoForUi());
    if (window.location.hash === HASH) startOpen();
    var tries = 0;
    var timer = window.setInterval(function () {
      hookHeicFrames();
      hookPrintify();
      hookPrintifyIframes();
      hookMediaGallery();
      syncPreviewProperty();
      syncBuyUi(hasPhotoForUi());
      tries += 1;
      if (tries > 40) window.clearInterval(timer);
    }, 250);
    window.setInterval(syncPreviewProperty, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
